<template lang="pug">
span.d-flex.align-end
  v-icon(@click="copySpreadsheetData" :class="{'disabled': disabled}").hoverable.copy-btn mdi-content-copy
  v-menu(:disabled="disabled")
    template(v-slot:activator="{ on }")
      v-icon(v-on="on" small :class="{'disabled': disabled}").copy-arrow mdi-menu-down
    v-list.user-menu
      v-list-item(@click="copyName").user-menu__item
        v-list-item-title Copy name
      v-list-item(@click="copyPhone")
        v-list-item-title Copy telephone number

</template>

<script>
import copyMixin from '@/mixins/copy.mixin'

export default {
  mixins: [copyMixin],
  props: {
    multiple: {
      type: Boolean
    },
    activeItems: Array,
    list: Array,
    model: Object,
    disabled: Boolean,
    custom: Function
  },

  methods: {
    copySpreadsheetData() {
      if(this.disabled) return
      if(this.custom) return this.custom()
      if(this.multiple) this.copyMultiple(this.getMultipleSpreadsheetData())
      else this.copyData(this.model)
    },

    getMultipleSpreadsheetData() {
      return this.activeItems.map(item => item.getSpreadsheetData(this.$store))
      let activeItemsIndex = this.getIndexesOf(this.activeItems)
      return activeItemsIndex.map(index => this.list[index].getSpreadsheetData(this.$store))
    },

    copyMultiple(data) {
      this.copy(data.join('\n'))
    },


    getIndexesOf(activeItems) {
      return this.activeItems.map(item => this.list.findIndex(_item => _item.ID === item.ID))
        .sort((a, b) => a - b)
    },
  
    copyData(model) {
      let data = model.getSpreadsheetData(this.$store)
      this.copy(data)
    },

    copyName() {
      if(this.multiple) this.copyMultiple(this.getMultipleDataBy('fullName'))
      else this.copy(this.model.fullName)
    },

    getMultipleDataBy(field) {
      let activeItemsIndex = this.getIndexesOf(this.activeItems)
      return activeItemsIndex.map(index => this.list[index][field])
    },

    copyPhone() {
      if(this.multiple) this.copyMultiple(this.getMultipleDataBy('candidateTel'))
      else this.copy(this.model.candidateTel)
    }
  }
}
</script>

<style lang="scss" scoped>
.copy-arrow::v-deep {
  &:hover {
    color: $primary-color;
  }
  &.disabled {
    opacity: .5;
    color: inherit;
    cursor: not-allowed;
  }
  
}

.copy-btn::v-deep {
  &.disabled {
    opacity: .5;
    color: inherit !important;
    cursor: not-allowed;
  }
}
</style>